var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "#F3F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4139_30995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19.9028V18.75C25.5 17.0955 24.1545 15.75 22.5 15.75C20.8455 15.75 19.5 17.0955 19.5 18.75V19.9028C18.6038 20.4225 18 21.3923 18 22.5V24C18 25.6545 19.3455 27 21 27H24C25.6545 27 27 25.6545 27 24V22.5C27 21.3923 26.3962 20.4225 25.5 19.9028ZM21 18.75C21 17.9227 21.6727 17.25 22.5 17.25C23.3273 17.25 24 17.9227 24 18.75V19.5H21V18.75ZM25.5 24C25.5 24.8273 24.8273 25.5 24 25.5H21C20.1727 25.5 19.5 24.8273 19.5 24V22.5C19.5 21.6727 20.1727 21 21 21H24C24.8273 21 25.5 21.6727 25.5 22.5V24ZM23.625 23.25C23.625 23.871 23.121 24.375 22.5 24.375C21.879 24.375 21.375 23.871 21.375 23.25C21.375 22.629 21.879 22.125 22.5 22.125C23.121 22.125 23.625 22.629 23.625 23.25ZM15 18C17.4818 18 19.5 15.9818 19.5 13.5C19.5 11.0182 17.4818 9 15 9C12.5182 9 10.5 11.0182 10.5 13.5C10.5 15.9818 12.5182 18 15 18ZM15 10.5C16.6545 10.5 18 11.8455 18 13.5C18 15.1545 16.6545 16.5 15 16.5C13.3455 16.5 12 15.1545 12 13.5C12 11.8455 13.3455 10.5 15 10.5ZM16.4925 20.4083C16.434 20.8185 16.0553 21.105 15.6442 21.0458C15.4313 21.015 15.2137 21 15 21C12.5182 21 10.5 23.0182 10.5 25.5V26.25C10.5 26.664 10.164 27 9.75 27C9.336 27 9 26.664 9 26.25V25.5C9 22.1918 11.6918 19.5 15 19.5C15.2842 19.5 15.5722 19.5203 15.8558 19.5608C16.266 19.6193 16.551 19.9987 16.4932 20.409L16.4925 20.4083Z",
    fill: "#AB44DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4139_30995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPassword);
export default __webpack_public_path__ + "static/media/user-password.144a14d712c70d8329dc4f4b32428994.svg";
export { ForwardRef as ReactComponent };